import { useMemo } from "react";
import { useIntl } from "react-intl";

import "../LocationFilter/LocationFilter.scss";
import Dropdown from "components/atoms/Dropdown/Dropdown";
import testIds from "constants/testIds";

type GeocodedFilterProps = {
  onChange: (value: string) => void;
};

export default function GeocodedFilter({ onChange }: GeocodedFilterProps) {
  const intl = useIntl();

  const options = useMemo(
    () => [
      {
        label: intl.formatMessage({
          id: "settings.address-book.geocodedFilter.all",
          defaultMessage: "All",
        }),
        value: "",
      },
      {
        label: intl.formatMessage({
          id: "settings.address-book.geocodedFilter.geocoded",
          defaultMessage: "Geocoded",
        }),
        value: "yes",
      },
      {
        label: intl.formatMessage({
          id: "settings.address-book.geocodedFilter.notGeocoded",
          defaultMessage: "Not geocoded",
        }),
        value: "no",
      },
    ],
    [intl],
  );

  const defaultLabel = options[0].label;

  return (
    <div className="filter-dropdown-wrapper">
      <Dropdown
        options={options}
        onChange={(item) => onChange(item.value)}
        defaultValue={defaultLabel}
        data-testid={testIds.ADDRESS_BOOK_GEOCODED_FILTER_DROPDOWN}
      />
    </div>
  );
}
